import React from 'react';
import styled from 'styled-components';
import { SectionParent, H3, H1, BlueButton } from '../../StyledComponents';
import TestIcon from '../../../assets/v2/Test/test-icon.svg';
import DeployIcon from '../../../assets/v2/Test/deploy-test.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import DebugIcon from '../../../assets/v2/Test/debug-test.svg';
import { navigate } from '@reach/router';
const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background-color: #222a46;
  padding-bottom: 3rem !important;
`;

const BlueButtonWrapper = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: fit-content;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 3rem;
  grid-gap: 6rem 10rem;
  @media (max-width: 1920px) {
    grid-gap: 3rem 6rem;
  }

  @media (max-width: 1024px) {
    grid-gap: 4rem 8rem;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  padding-right: 1rem;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
  @media (max-width: 520px) {
    font-size: 14px;
    margin-bottom: 0;
    line-height: normal;
  }
`;

const TitlesContainer = styled.div`
  padding-top: 1rem;
  padding-right: 1rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const GridTitle = styled.div`
  font-size: 22px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  text-align: center;
  line-height: normal;
  letter-spacing: normal;
  color: #b2efbb;
  @media (max-width: 520px) {
    min-height: 2.5rem;
    font-size: 18px;
    margin-bottom: -1rem;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  min-height: 6rem;
  align-items: center;
  justify-content: center;
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

const SectionTitle = styled(H1)`
  padding-top: 2rem;
  @media (max-width: 520px) {
    text-align: center;
  }

  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #5f4aa1;
`;

export default () => (
  <>
    <Section>
      <GridContainer>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={TestIcon} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Test</GridTitle>
          </TitlesContainer>
          <GridItemContent>On real devices</GridItemContent>
        </GridItem>
        <GridItem>
          <ImgWrapper>
            <StyledImg src={DeployIcon} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Deploy</GridTitle>
          </TitlesContainer>
          <GridItemContent>Applications from Android Studio</GridItemContent>
        </GridItem>
        <GridItem>
          {' '}
          <ImgWrapper>
            <StyledImg src={DebugIcon} />
          </ImgWrapper>
          <TitlesContainer>
            <GridTitle>Debug</GridTitle>
          </TitlesContainer>
          <GridItemContent>Via secure remote adb</GridItemContent>
        </GridItem>
      </GridContainer>
    </Section>
  </>
);
